import React, { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'

import { BaseView, BaseText } from '@/components/base'
import { AppButton, StickyHeaderNavigation } from '@/components'
import { TextInputForm } from '@/components/form'
import { useRequestCurrentEmailVerificationCode } from '@/domain'
import { useProfileUpdateStore } from '@/store/profileUpdate'

export const AddNewEmailScreen: React.FC = () => {
  const { t } = useTranslation()
  const navigate = useNavigate()
  const [email, setEmail] = useState('')

  const { setProfileUpdateFormState } = useProfileUpdateStore()

  const { requestCurrentEmailVerificationCode, isLoading } =
    useRequestCurrentEmailVerificationCode({
      onSuccess: () => {
        // Navigate to validate code page
        navigate('/profile/update-profile/update-email/validate-code')
      },
      onError: ({ errorMessage }) => {
        console.error('Error requesting email verification code:', errorMessage)
      },
    })

  const handleSubmit = () => {
    if (email.trim()) {
      setProfileUpdateFormState({
        newEmail: email.trim(),
      })
      requestCurrentEmailVerificationCode()
    }
  }

  const handleGoBack = () => {
    navigate(-1)
  }

  return (
    <BaseView flex={1} bgColor="background.screen" className="h-full">
      {/* Fixed Header Navigation */}
      <StickyHeaderNavigation
        title={t(
          'screens:profile.profileSettings.items.editProfile.updateEmail',
        )}
        onBackPress={handleGoBack}
      />

      {/* Scrollable Content */}
      <BaseView
        flex={1}
        px={12}
        style={{
          overflowY: 'auto',
        }}
      >
        <BaseView gap={16}>
          <BaseText
            fontSize={14}
            fontFamily="regular"
            color="label.description"
          >
            {t('translation:editEmail.enterTheNewEmail')}
          </BaseText>

          <TextInputForm
            name="email"
            label={t('form:fields.email')}
            value={email}
            onChangeText={setEmail}
            keyboardType="email-address"
            autoCapitalize="none"
            autoComplete="email"
          />
        </BaseView>

        {/* Footer Button */}
        <BaseView
          style={{
            position: 'fixed',
            bottom: 0,
            left: 0,
            right: 0,
            padding: '24px 12px',
            backgroundColor: 'var(--background-screen)',
            borderTop: '1px solid var(--background-card-item-root)',
          }}
        >
          <AppButton
            label={t('form:actions.update')}
            onClick={handleSubmit}
            disabled={!email.trim()}
            isLoading={isLoading}
          />
        </BaseView>
      </BaseView>
    </BaseView>
  )
}
